import { useMutation, type UseMutationOptions } from '@tanstack/react-query'
import { transactionSettingsService } from '../services'
import type {
	TransactionSchedule,
	CreateTransactionScheduleDto,
	UpdateTransactionScheduleDto,
	TransactionType,
} from '../../types'

type CreateScheduleOptions = UseMutationOptions<
	TransactionSchedule,
	Error,
	{ type: TransactionType; data: CreateTransactionScheduleDto }
>

export const useMutationCreateSchedule = (options?: CreateScheduleOptions) => {
	return useMutation({
		mutationFn: ({
			type,
			data,
		}: {
			type: TransactionType
			data: CreateTransactionScheduleDto
		}) => transactionSettingsService.createSchedule(type, data),
		...options,
	})
}

type UpdateScheduleOptions = UseMutationOptions<
	TransactionSchedule,
	Error,
	{ id: string; type: TransactionType; data: UpdateTransactionScheduleDto }
>

export const useMutationUpdateSchedule = (options?: UpdateScheduleOptions) => {
	return useMutation({
		mutationFn: ({
			id,
			type,
			data,
		}: {
			id: string
			type: TransactionType
			data: UpdateTransactionScheduleDto
		}) => transactionSettingsService.updateSchedule(id, data, type),
		...options,
	})
}

type DeleteScheduleOptions = UseMutationOptions<
	TransactionSchedule,
	Error,
	{ id: string; type: TransactionType }
>

export const useMutationDeleteSchedule = (options?: DeleteScheduleOptions) => {
	return useMutation({
		mutationFn: ({ id, type }: { id: string; type: TransactionType }) =>
			transactionSettingsService.deleteSchedule(id, type),
		...options,
	})
}
